import * as React from 'react';
import { ThemeContext } from 'styled-components';

import { VALID_FONTS } from '../../../lib/StyledComponents/Theme/common';
import { Box } from '../Layout/Box';
import { VALID_FONT_WEIGHTS } from '../Typography/common';
import { VALID_COLOR_DATA, VALID_FONT_SIZE_DATA } from '../Utils';

import {
  DescriptionGroupContext,
  IDescriptionGroupContext,
  useDescriptionListContext
} from './DescriptionListContext';

export interface IIDescriptionContentTheme {
  size?: VALID_FONT_SIZE_DATA;
  color?: VALID_COLOR_DATA;
  lineHeight?: string;
  family?: VALID_FONTS;
  weight?: VALID_FONT_WEIGHTS;
}

const DescriptionGroup: React.FC<IDescriptionGroupContext> = ({ children, detail, term, variant }) => {
  const { themeTwo: { descriptionList: { group }} } = React.useContext(ThemeContext);
  const { align, direction, stacked, noMobileStack } = useDescriptionListContext();

  return (
    <DescriptionGroupContext.Provider value={{ detail, term, variant }}>
      <Box
        direction={direction}
        justifyContent={!stacked || !noMobileStack ? align : undefined}
        alignItems={stacked || noMobileStack ? align : undefined}
        margin={group.margin}
      >
        {children}
      </Box>
    </DescriptionGroupContext.Provider>
  );
};

export default DescriptionGroup;
